import { Button } from '@mui/material'
import React from 'react'

const OutlinedButton = ({ onClick, btnName }) => {
    return (
        <Button
            onClick={onClick}
            sx={{
                border: '1px solid #888',
                color: '#888',
                borderRadius: '6px',
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: '#b9b9b9',
                    color: '#222',
                    borderColor: '#b9b9b9'
                }
            }}
        >
            {btnName}
        </Button>
    )
}

export default OutlinedButton
